export const IS_CUBE_UI = true;
